<template>
  <footer>
    <div class="main-footer">
      <FooterNav :user="user" />
    </div>
    <section>
      <CopyrightSection />
    </section>
  </footer>
</template>

<script>
import CopyrightSection from '../CopyrightSection/CopyrightSection';
import FooterNav from '../FooterNav/FooterNav';

export default {
  name: 'MainFooter',
  props: {
    user: {
      type: Object
    }
  },
  components: {
    FooterNav,
    CopyrightSection
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.main-footer {
  padding: 60px 0;
  background-color: $dark-blue;

  @media (max-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  > .footer-inner {
    margin: auto;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>

<style lang="scss">
@import '../../assets/sass/config';
  .main-footer .footer-nav {
    .footer-links-list-heading {
      color: #fff;
    }

    .footer-menu-item {
      a {
        color: $light-teal;

        &:hover {
          color: #fff;
        }
      }
    }
  }
</style>

